// src/components/common/Navbar.jsx
import React from 'react';

const Navbar = ({ toggleSidebar }) => {
  return (
    <nav className="navbar navbar-light bg-light border-bottom px-3">
      <button className="btn btn-outline-primary" onClick={toggleSidebar}>
        <i className="fas fa-bars"></i>
      </button>
      <span className="navbar-brand ms-3 fw-bold">DMS</span>
    </nav>
  );
};

export default Navbar;
